import React from 'react';

const LoadingSpinner = ({ size = 'md', text }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="flex flex-col items-center justify-center p-8" data-testid="loading-spinner">
      <div
        className={`${sizeClasses[size]} border-4 border-[var(--gg-lgray)] border-t-[var(--gg-purple)] rounded-full animate-spin`}
      />
      {text && (
        <p className="mt-4 text-sm text-[var(--text-secondary)]">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
